export default [
    {
        name: 'environmentMapTexture',
        type: 'cubeTexture',
        path: [
            '/textures/environmentMaps/0/px.png',
            '/textures/environmentMaps/0/nx.png',
            '/textures/environmentMaps/0/py.png',
            '/textures/environmentMaps/0/ny.png',
            '/textures/environmentMaps/0/pz.png',
            '/textures/environmentMaps/0/nz.png'
        ]
    },
    {
        name: 'snowTexture',
        type: 'texture',
        path: '/textures/weather/snow.png'
    },
    {
        name: 'googleTexture',
        type: 'texture',
        path: '/textures/icons/google.png',
        link: 'https://www.google.com/'
    },
    {
        name: 'githubTexture',
        type: 'texture',
        path: '/textures/icons/github.png',
        link: 'https://github.com/msroque'
    },
    {
        name: 'linkedinTexture',
        type: 'texture',
        path: '/textures/icons/linkedin.png',
        link: 'https://www.linkedin.com/in/michelle-roque'
    },
    {
        name: 'uiuxTexture',
        type: 'texture',
        path: '/textures/icons/uiux.png',
        link: 'https://uiux-michelle-roque.vercel.app/'
    },
    {
        name: 'backgroundsTexture',
        type: 'texture',
        path: '/textures/icons/backgrounds.png',
        link: './backgrounds.html'
    },
    {
        name: 'whtPlayTexture',
        type: 'texture',
        path: '/textures/buttons/wht_play_00.png'
    },
    {
        name: 'blkPlayTexture',
        type: 'texture',
        path: '/textures/buttons/blk_play_00.png'
    },
    {
        name: 'whtBackTexture',
        type: 'texture',
        path: '/textures/buttons/wht_back_00.png'
    },
    {
        name: 'blkBackTexture',
        type: 'texture',
        path: '/textures/buttons/blk_back_00.png'
    },
    {
        name: 'test_01',
        type: 'texture',
        path: '/textures/icons/b3300_desc_pic.jpg'
    },
    {
        name: 'testThumbnail_01',
        type: 'texture',
        path: '/textures/icons/b3300.png'
    },
    {
        name: 'marble_desc',
        type: 'texture',
        path: '/textures/icons/marble_desc_2.png'
    },
    {
        name: 'marble_desc_pic',
        type: 'texture',
        path: '/textures/icons/marble_desc.png'
    },
    {
        name: 'marbleThumbnail',
        type: 'texture',
        path: '/textures/icons/marble.jpg'
    },
    {
        name: 'desc_01',
        type: 'texture',
        path: '/textures/icons/b3300_desc.png'
    },
    {
        name: 'aboutMeThumbnail',
        type: 'texture',
        path: '/textures/icons/about_me.png'
    },
    {
        name: 'aboutMeDesc',
        type: 'texture',
        path: '/textures/icons/about_me.jpg'
    },
    {
        name: 'workExp',
        type: 'texture',
        path: '/textures/icons/work_exp_s.jpg'
    },
    {
        name: 'skills',
        type: 'texture',
        path: '/textures/icons/skills.png'
    },
    {
        name: 'title',
        type: 'font',
        text: 'M   I   C   H   E   L   L   E         R   O   Q   U   E',
        size: 1.05,
        height: 0.2,
        path: 'fonts/helvetiker_bold.typeface.json',
        texturePath: '/textures/matcaps/1.png'
    },
    {
        name: 'aboutMeTitle',
        type: 'font',
        text: "H   I   ,         I   '   M         M   I   C   H   E   L   L   E",
        size: 1.35,
        height: 0.2,
        path: 'fonts/helvetiker_bold.typeface.json',
        texturePath: '/textures/matcaps/1.png'
    },
    {
        name: 'workTitle',
        type: 'font',
        text: 'A   C   T   I   V   I   T   I   E   S',
        size: 1.05,
        height: 0.2,
        path: 'fonts/helvetiker_bold.typeface.json',
        texturePath: '/textures/matcaps/1.png'
    },
    {
        name: 'skillsTitle',
        type: 'font',
        text: 'S   K   I   L   L   S',
        size: 1.05,
        height: 0.2,
        path: 'fonts/helvetiker_bold.typeface.json',
        texturePath: '/textures/matcaps/1.png'
    }

]
